import React from 'react';
import { Link, type LinkProps } from 'react-router-dom';
import { useTabNavigate } from '@/hooks/useTabNavigate';

const TabLink = React.forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => {
  const navigate = useTabNavigate();
  return (
    <Link
      {...props}
      ref={ref}
      to={props.to}
      onClick={async (e) => {
        e.preventDefault();
        let prevent = false;

        await props.onClick?.({
          ...e,
          preventDefault() {
            prevent = true;
          },
        });

        if (prevent) {
          return;
        }

        const { target = '_self' } = props;

        if (target === '_self') {
          navigate(props.to);
          return;
        }

        window.open(`${props.to}`, target);
      }}
    >
      {props.children}
    </Link>
  );
});

TabLink.displayName = 'TabLink';

export default TabLink;
